import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useConfig } from "../context/Config";
import Overview from "./Overview/Overview";

import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import "../style.scss";

import PositivacaoTotalDesktop from "./PositivacaoTotal/PositivityCategoryDesktop";
import Details from "./Details/Details";
import PositivityCategoryDesktop from "./PositivacaoCategory/PositivityCategoryDesktop";
import InsightsDesktop from "./Insights/InsightsDesktop";
import Faq from "./Faq";
import { RegrasCampanhas } from "./RegrasCamapnha";
import { Investigation } from "./Investigation";
import { RankingGeral } from "./RankingGeral";

function Layout() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <div className="container-app">
          <LeftSideMenu app={app} config={config} />

          <Switch>
            <Route exact path="/">
              <Redirect to="/overview" />
            </Route>
            <Route
              path="/overview"
              exact
              render={() => <Overview app={app} config={config} />}
            />
            <Route
              path="/positivity-total"
              exact
              render={() => (
                <PositivacaoTotalDesktop app={app} config={config} />
              )}
            />

            <Route
              path="/positivity-category"
              exact
              render={() => (
                <PositivityCategoryDesktop app={app} config={config} />
              )}
            />

            <Route
              path="/details"
              exact
              render={() => <Details app={app} config={config} />}
            />

            <Route
              path="/investigation"
              exact
              render={() => <Investigation app={app} config={config} />}
            />

            <Route
              path="/insights"
              exact
              render={() => <InsightsDesktop app={app} config={config} />}
            />

            <Route
              path="/ranking-geral"
              exact
              render={() => <RankingGeral app={app} config={config} />}
            />

            <Route
              path="/faq"
              exact
              render={() => <Faq app={app} config={config} />}
            />

            <Route
              path="/roles"
              exact
              render={() => <RegrasCampanhas app={app} config={config} />}
            />
          </Switch>
        </div>
      </HashRouter>
    </div>
  );
}

export default Layout;
